import React, { useState, useEffect, useCallback } from 'react';
import { Button, Classes, Dialog } from '@blueprintjs/core';
import { useTranslation } from 'react-i18next';
import { CaseModel } from 'data/case/case.types';
import { FormTemplate } from 'data/template/template.types';
import { DeviceModelMap } from 'xcipio/devices/device.types';
import CasesConfirmationForm from './components/CasesConfirmationForm';

interface CasesInfoConfirmationProps {
  cases: CaseModel[]
  show: boolean
  warrantTemplate: FormTemplate
  devicesToConfirm: DeviceModelMap
  isNokamflcsimEnabled?: boolean
  isDisplayLocDataInInterceptDropDownEnabled?: boolean
  onClose: () => void
  onSubmit: () => void
}

const CasesInfoConfirmation = ({
  cases,
  show,
  warrantTemplate,
  devicesToConfirm,
  isNokamflcsimEnabled = false,
  isDisplayLocDataInInterceptDropDownEnabled = false,
  onClose,
  onSubmit,
}: CasesInfoConfirmationProps): JSX.Element => {
  const { t } = useTranslation();
  const [currentCaseIndex, setCurrentCaseIndex] = useState(0);

  useEffect(() => {
    if (show) {
      setCurrentCaseIndex(0);
    }
  }, [show]);

  const handleBackButton = () => {
    if (currentCaseIndex > 0) {
      setCurrentCaseIndex(currentCaseIndex - 1);
    }
  };

  const handleNextButton = () => {
    if (currentCaseIndex < cases.length - 1) {
      setCurrentCaseIndex(currentCaseIndex + 1);
    }
  };

  const handleConfirmButton = () => {
    onSubmit();
  };

  const renderCasesConfirmationForm = useCallback(() => {
    return (
      <CasesConfirmationForm
        caseNumber={currentCaseIndex + 1}
        currentCase={cases[currentCaseIndex]}
        warrantTemplate={warrantTemplate}
        countCasesToConfirm={cases.length}
        devicesToConfirm={devicesToConfirm}
        isNokamflcsimEnabled={isNokamflcsimEnabled}
        isDisplayLocDataInInterceptDropDownEnabled={isDisplayLocDataInInterceptDropDownEnabled}
        onClose={onClose}
        onBack={handleBackButton}
        onNext={handleNextButton}
        onSubmit={handleConfirmButton}
      />
    );
  }, [currentCaseIndex, cases]);

  return (
    <Dialog
      data-testid="cases-info-confirmation-dialog"
      autoFocus
      title={t('warrant.create.confirmValues', { currentCase: currentCaseIndex + 1, totalCases: cases.length })}
      onClose={onClose}
      isOpen={show}
      className="vpn-configuration-popup"
    >
      <div className={Classes.DIALOG_BODY}>
        <div data-testid="VPNConfigurationPopup-confirmation" />
        {renderCasesConfirmationForm()}
      </div>
    </Dialog>
  );
};

export default CasesInfoConfirmation;
